class AnchorList{
    constructor(el) {
        this.scope = el;
        this.links = el.querySelectorAll("a");
        this.bindEvents();
    }
    
    bindEvents(){
        this.links.forEach(link =>{
            link.addEventListener("click", ()=>{
                this.toggleLink(link);
            })
        })
    }
    
    toggleLink(targetLink){
        this.links.forEach(link => {
            link.classList.toggle("anchor-list-block__items__item__link--active", link === targetLink);
        })
    }
}

ControlBinders.register('[data-anchor-list]', el => new AnchorList(el));